import { Restaurant } from "../interfaces/Catalogue";

/**
 * Builds the best possible Google Maps URL from available restaurant data.
 * Priority: lat/lng > address > name only.
 * Opens Google Maps on the place — user taps "Reviews" → "Write a review".
 */
export const buildGoogleMapsReviewUrl = (restaurant: Restaurant): string => {
  const name = encodeURIComponent(restaurant.nom);

  // Best: coordinates + name (most precise, pins the exact spot)
  if (restaurant.latitude && restaurant.longitude) {
    const query = encodeURIComponent(`${restaurant.nom} ${restaurant.address ?? ""}`);
    return `https://www.google.com/maps/search/?api=1&query=${query}&center=${restaurant.latitude},${restaurant.longitude}`;
  }

  // Good: name + address
  if (restaurant.address) {
    const query = encodeURIComponent(`${restaurant.nom} ${restaurant.address}`);
    return `https://www.google.com/maps/search/?api=1&query=${query}`;
  }

  // Fallback: name only
  return `https://www.google.com/maps/search/?api=1&query=${name}`;
};